import { defineMessages } from "react-intl";

const SOURCE_SIGN_IN = "source-sign-in";

const sourceSignInMessages = defineMessages({
  takeItWithYou: {
    id: `${SOURCE_SIGN_IN}.take-it-with-you`,
    defaultMessage: "Take it with you"
  },
  mergeDataFromAccount: {
    id: `${SOURCE_SIGN_IN}.merge-data-from-account`,
    defaultMessage:
      "Merge user account data from one EBSCO account to another (personal user account)."
  },
  signIntoDifferentAccount: {
    id: `${SOURCE_SIGN_IN}.sign-into-different-account`,
    defaultMessage:
      "To continue, please sign in to a different personal user account which you would like to merge into your current account. You must own both accounts."
  },
  signIntoSecondAccount: {
    id: `${SOURCE_SIGN_IN}.sign-in-to-second-account`,
    defaultMessage: "Sign in to your second account"
  }
});

export default sourceSignInMessages;
